<template>
  <v-list class="sub-navigation-list">
    <v-list-item
      v-for="(item, index) in items"
      :to="item.globalTo || (item.to && `${to}/${item.to}`)"
      :href="item.href"
      :target="item.globalTo || item.to ? '_self' : '_blank'"
      :key="index"
      >{{ $t(item.text) }}</v-list-item
    >
  </v-list>
</template>
<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  props: ["items", "to"],
});
</script>
<style lang="scss">
.app-navigation .sub-navigation-list .v-list-item {
  padding-left: 32px !important;
}
</style>
